var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C2.89543 6 2 6.89543 2 8V12.0679C1.99951 12.0808 1.99927 12.0936 1.99927 12.1066C1.99927 12.1195 1.99951 12.1324 2 12.1452V24C2 25.1046 2.89543 26 4 26H28C29.1046 26 30 25.1046 30 24V8C30 6.89543 29.1046 6 28 6H4ZM4 13.1066V24H28V13.1066H4ZM28 11.1066V8H4V11.1066H28ZM20.9993 20C20.447 20 19.9993 20.4477 19.9993 21C19.9993 21.5523 20.447 22 20.9993 22H24.9993C25.5516 22 25.9993 21.5523 25.9993 21C25.9993 20.4477 25.5516 20 24.9993 20H20.9993ZM13.9993 21C13.9993 20.4477 14.447 20 14.9993 20H16.9993C17.5516 20 17.9993 20.4477 17.9993 21C17.9993 21.5523 17.5516 22 16.9993 22H14.9993C14.447 22 13.9993 21.5523 13.9993 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.bf4cb758.svg";
export { ForwardRef as ReactComponent };